import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbStepInfoView", { params: params });
  },

  findAllByFlowId(flowId) {
    return httpService.get("vbStepInfoView/findAllByFlowId", {
      params: { flowId }
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbStepInfoViewService.js